module.exports = __webpack_public_path__ + "static/img/weChatPaymentIcon.93816b09.png";